import { IActiveModal } from "src/pages/Admin/AdminWindow";
import { DeviceDataGrid, IDeviceGridEndpoints } from "../DeviceGrid";

interface ICrewDeviceDataGridProps {
  setActiveModal: (activeModal: IActiveModal | null) => void;
}

/** Crew EFB devices, stored at `crewInfo.efbDevices` on the user record. */
const CREW_DEVICE_ENDPOINTS: IDeviceGridEndpoints = {
  list: "/crew/efb/list",
  invite: (userId) => `/crew/efb/invite/${userId}`,
  device: (deviceId) => `/crew/efb/device/${deviceId}`,
  setState: (state, deviceId) => `/crew/efb/set/${state}/${deviceId}`,
  bulkRemove: "/crew/efb/bulk/remove",
  bulkSetState: (state) => `/crew/efb/bulk/set/${state}`,
};

export const CrewDeviceDataGrid = (props: ICrewDeviceDataGridProps): JSX.Element => (
  <DeviceDataGrid
    setActiveModal={props.setActiveModal}
    endpoints={CREW_DEVICE_ENDPOINTS}
    memberNoun="crew member"
    memberColumnHeader="Crew Member"
    // This tab has always rendered batteryLevel straight into the bar, i.e. read
    // it as an already-scaled percentage. The User Devices tab multiplies by 100
    // instead. Only one can be right, but that predates ENG-602, so each tab
    // keeps the reading its admins are used to until it is settled separately.
    batteryScale={1}
    emptyMessage="No crew devices have been registered yet."
  />
);

export default CrewDeviceDataGrid;
